import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Page, SelectField, StyledButton, Loadable } from "components/support";

class XmlsView extends Component {
  static months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];

  state = {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  };

  constructor(props) {
    super(props);

    this.presenter = props.presenter;
  }

  getMonths() {
    return XmlsView.months.map((month, index) => ({
      label: month,
      value: index + 1
    }));
  }

  getYears() {
    const year = new Date().getFullYear();
    const limit = year - 10;
    let response = [];
    for (let i = year; i >= limit; i--) {
      response.push({
        label: i.toString(),
        value: i
      });
    }
    return response;
  }

  handleDownloadButton = () => {
    return this.presenter.onDownloadButton(this.state.month, this.state.year);
  };

  render() {
    const { loading } = this.props.viewModel;
    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          XMLS Contabilidade
        </Typography>
        <Loadable loading={loading}>
          <Paper elevation={1} className="p-sm">
            <Row className="ph-sm">
              <Typography type="headline">
                Selecione a data para exportar os arquivos de contabilidade
              </Typography>
            </Row>
            <Row bottom="lg" around="xs">
              <Col xs={12} sm={5}>
                <SelectField
                  value={this.state.month}
                  onChange={(e, value) => this.setState({ month: value })}
                  fullWidth
                  label="Mês"
                  options={this.getMonths()}
                />
              </Col>
              <Col xs={12} sm={5}>
                <SelectField
                  value={this.state.year}
                  onChange={(e, value) => this.setState({ year: value })}
                  fullWidth
                  sortBy="label"
                  label="Ano"
                  options={this.getYears()}
                />
              </Col>
              <Col xs={12} sm={2} style={{ padding: 3, marginTop: 6 }}>
                <StyledButton
                  label="Baixar XMLs"
                  onTouchTap={this.handleDownloadButton}
                  accent
                  fullWidth
                />
              </Col>
            </Row>
          </Paper>
        </Loadable>
      </Page>
    );
  }
}

export default XmlsView;



// WEBPACK FOOTER //
// ./src/components/app/history/xmls/xmls.view.js